function deliverDate(e) {
  var dateContainer = $('.delivery-date');
  var now = moment();
  var countryAdjust = 0;
  //var countryAdjust = (typeof(e) != 'undefined') ? e: 0;
  var startDate = now;
  var limit = 6;
  var delRange = '3';
  var delRange = dateContainer.data('getdate');
  var day1;
  var day2;
  var hours = parseInt($('.product-page-wrapper').attr('data-time').split(':')[0]);
  var minutes = parseInt($('.product-page-wrapper').attr('data-time').split(':')[1]);
  var seconds = parseInt($('.product-page-wrapper').attr('data-time').split(':')[2]);
  var nearest_round =  moment(now).minute() || moment(now).second() || moment(now).millisecond() ? moment(now).add(1, 'hour').startOf('hour') : moment(now).startOf('hour');
  if(!window.sessionStorage.getItem('sessionTime')){
    var newDateObj = nearest_round.add(hours, 'h').add(minutes,'m').add(seconds,'s').toDate();
  }
  else{
  	var newDateObj = window.sessionStorage.getItem('sessionTime');
  }
	countdown(newDateObj);
  // Adjusts the startdate to monday if it's Friday or weekend 
  if((now.format('ddd')).indexOf('Fri') > -1){
    startDate = now.clone().add(3, 'd');
  } else if((now.format('ddd')).indexOf('Sat') > -1) {
    startDate = now.clone().add(2, 'd');
  } else if((now.format('ddd')).indexOf('Sun') > -1) {
    startDate = now.clone().add(1, 'd');
  }

  //console.log('Adjusted date: ' + startDate.format('dddd, MMMM Do YYYY'));
  try{
  var range1 = Number((delRange.split('-')[0]).replace(/\s/g, ''));
  var range2 = isNaN(delRange.split('-')[1]) ? Number((delRange.split('-')[0]).replace(/\s/g, '')) : Number((delRange.split('-')[1]).replace(/\s/g, ''));
  }
  catch(err){
     	var range1 = delRange;
  	  var range2 = delRange;
  }
  if(range2 <= 5) {
    range1 = range1 + countryAdjust;
  	range2 = range2 + countryAdjust;
  }

  //console.log('Delivery Range: ' + range1 + '-' + range2);
  //console.log('Country Adjust: ' + countryAdjust);

  day1 = startDate.clone().add(range1, 'd');
  day2 = startDate.clone().add(range2, 'd');

  // Adjusts the deliverydate to monday if it's Friday or weekend 
  if((day1.format('ddd')).indexOf('Sat') > -1) {
    day1 = day1.clone().add(2, 'd');
    day2 = day2.clone().add(2, 'd');
  } else if((day1.format('ddd')).indexOf('Sun') > -1) {
    day1 = day1.clone().add(1, 'd');
    day2 = day2.clone().add(1, 'd');
  }

  if((day2.format('ddd')).indexOf('Sat') > -1) {
    day2 = day2.clone().add(2, 'd');
  } else if((day2.format('ddd')).indexOf('Sun') > -1) {
    day2 = day2.clone().add(1, 'd');
  }

  //console.log(day1.format('dddd, MMMM Do YYYY'));
  //console.log(day2.format('dddd, MMMM Do YYYY'));
  if(range2 > limit){
    dateContainer.html('by '+day2.format('dddd')+', '  + day2.format('MMMM Do'));
  } else {
    if(range1 != range2){
      dateContainer.html('between ' + day1.format('dddd') + ' and ' + day2.format('dddd'));
    } else {
      dateContainer.html('on ' + day2.format('dddd')+', '  + day2.format('MMMM Do'));
    }
  }
  //console.log('-----------------------------');
}

if (window.location.href.indexOf('/products/') > -1) {
  
  deliverDate();
  
  fetch('https://api.ipregistry.co/?key=0ch6zugzw8a2h580')
      .then(function (response) {
          return response.json();
      })
      .then(function (payload) {
    	console.log(payload);
        if(payload.location.city){
          $('.city-name').text('to '+ payload.location.city);
        }
          if(payload.location.country.code != 'US'){
            deliverDate(7);
          }
      });

  // --------------------------------------------------------------------------
}

$('.product-form__inner .jdgm-all-reviews-text').prependTo('.product-page-wrapper .product-page-wrapper__inner');

function moveElements() {
  var windowWidth = $(window).width();
  
  if (windowWidth < 1024) {
    
  } 
  else {
    //$('.mobile-rating .jdgm-all-reviews-text').prependTo('.product-form__inner > .shopify-block');
  } 
}

$(document).ready(function() {
  moveElements();   
  
  var doit;
  window.onresize = function(){
    clearTimeout(doit);
    doit = setTimeout(moveElements, 100);
  };
});

//------------------------------------------------------------------------------

$('.product-form').on('change', function() {
  var variantID = $('.product-form__controls-group--submit select').val();
  $('.bogo__button').attr('data-variant', variantID);
});

$('.bogo__button').click(function(e) {
  e.preventDefault();
  var currentVariant = $(this).attr('data-variant');
  var updates = "updates[" + currentVariant + "]=3";
  
  $.post('/cart/update.js', updates );
  
  window.setTimeout(function() {
    location.href = $('.bogo__button').attr('href');
  }, 1000);
});

$('.small-cart').click(function(e) {
  e.preventDefault();
  $('.product-form__submit-button-wrapper .product-form__cart-submit').click();
});

function monther() {
  const date = new Date();
  const month = date.toLocaleString('default', { month: 'long' });
  if (document.getElementById('month')){
    document.getElementById('month').innerHTML = month;
  }
}

monther();


var timer;
const COUNTER_KEY = 'my-counter';

function countDown(i, callback) {
  //callback = callback || function(){};
  timer = setInterval(function() {
    minutes = parseInt(i / 60, 10);
    seconds = parseInt(i % 60, 10);

    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    if (document.getElementById('countdown')){
    	document.getElementById('countdown').innerHTML = minutes + ":" + seconds;
    }

    if ((i--) > 0) {
      window.sessionStorage.setItem(COUNTER_KEY, i);
    } else {
      window.sessionStorage.removeItem(COUNTER_KEY);
      clearInterval(timer);
      callback();
    }
  }, 1000);
}

window.onload = function() {
  var countDownTime = window.sessionStorage.getItem(COUNTER_KEY) || 600;
  countDown(countDownTime, function() {
  });
};

$('.product-faq li:nth-child(odd)').click(function(e) {
  e.preventDefault();
  $(this).toggleClass('question-toggled');
  $(this).next().toggleClass('show-answer');
});

var discountHijacks = setInterval(function() {
   if ($('.cart-flyout.is-visible').length) {
     
     $('.cart-flyout .quick-cart__item-discounts li').each(function(){
       var discountName = $(this).text();
       if(discountName.indexOf('Free Gift') !== -1) {
         $(this).parents('.cart__item').addClass('is-free-gift');
       }
     });
   }
}, 100);
const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];

const d = new Date();
let name = month[d.getMonth()];
$('.template-cart').addClass(name);
function countdown(date){
  var countDownDate = new Date(date).getTime();
  var x = setInterval(function() {
    var now = new Date().getTime();
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    var timer_string = ("0" + hours).slice(-2)+':'+("0" + minutes).slice(-2)+':'+("0" + seconds).slice(-2);
    $('.remaining-time').html(timer_string);
    window.sessionStorage.setItem('sessionTime',date);
    if (distance < 0) {
      window.sessionStorage.setItem('sessionTime','');
      location.reload();
    }
  }, 1000);
}
$(document).ready(function(){
	var now = moment();
  $('.announcement-bar__content').each(function(i){
  	var text = $(this).text().replace('[date]',now.format('dddd')+', '  + now.format('MMMM Do'));
    $(this).text(text);
  })
})